import PopOver from 'app/scripts/views/lib/pop-over.coffee';
import React, { Fragment } from 'react';
import Util from 'app/scripts/lib/util/index.coffee';

import { forTemplate } from 'app/common/lib/util/i18n';
import { Button } from '@trello/nachos';

const format = forTemplate('advanced_checklists');

interface Options {
  clear: () => void;
  message: string;
  removeText: string;
  title: string;
  upsell: boolean;
}

export function toggleClearPopover({
  clear,
  message,
  removeText,
  title,
  upsell,
}: Options) {
  return function toggle(e: MouseEvent) {
    Util.stop(e);

    PopOver.toggle({
      elem: e.currentTarget,
      getViewTitle: () => title,
      keepEdits: true,
      reactElement: (
        <Fragment key={'clear'}>
          {upsell && (
            <p style={{ textAlign: 'center', padding: '12px 0' }}>{message}</p>
          )}
          <Button
            onClick={() => {
              PopOver.hide();
              clear.call(this);
            }}
            shouldFitContainer={true}
          >
            {removeText}
          </Button>
          {upsell && (
            <Button
              onClick={() => {
                PopOver.hide();
                window.open('/business-class');
              }}
              shouldFitContainer={true}
            >
              {format('upgrade-to-business-class')}
            </Button>
          )}
        </Fragment>
      ),
    });
  };
}
